import Vue from 'vue'

const GLOBAL_ENV = window.GLOBAL_ENV || {}
const GLOBAL_ENV_MODULE = require(`@/assets/config/env/${process.env.VUE_APP_GLOBAL_ENV}`)
const globalEnv = {
  ...GLOBAL_ENV_MODULE,
  ...GLOBAL_ENV
}

Vue.prototype.GLOBAL_ENV = Object.freeze(globalEnv)

Object.defineProperty(Vue, 'GLOBAL_ENV', {
  value: Object.freeze(JSON.parse(JSON.stringify(globalEnv))),
  configurable: false,
  writable: false,
  enumerable: false
})
